<template lang="pug">
  .b-stage-aside
    ._header
      ._title {{ stage.name }}
      BtnExpand._expand(:expanded="expanded" @toggle="expanded = !expanded")
      //router-link._create-task(v-if="isAdmin" :to="{ name: 'task-create', params: { stageId: stage.id } }")
        Icon(name="btn-add" pointer)
    ._tasks(:class="{ expanded }")
      ._task(v-for="task in tasks" :key="task.id" :class="{ curr: currTask.id === task.id, closed: task.isClosed }")
        ._status(:style="`background-color: ${getStatusColor(task)}`")
        Link._task-name(:to="{ name: 'task-detail', params: { projectId: stage.project.id, stageId: stage.id, taskId: task.id } }") {{ task.name }}
          template(v-if="notificationCount[task.id] > 0") {{ '&nbsp;' }}
            NotificationCount(:count="notificationCount[task.id]")
        BasePriority._task-priority(:level="task.priority" :editable="isAdmin" :gray="task.isClosed" @change="update(task.id, 'priority', $event)")
        UserUniversalTile._task-manager(:selected="task.manager" :editable="isAdmin && !task.isClosed" :items="$store.getters['project/members']" short @change="update(task.id, 'manager', $event)")
</template>

<script>
import taskListModel from '@/model/taskList';
import BasePriority from '@/components/BasePriority.vue';
import UserAvatar from '@/components/UserAvatar.vue';
import UserUniversalTile from '@/components/UserUniversalTile.vue';
import BtnExpand from '@/components/ui/BtnExpand.vue';
import NotificationCount from '@/components/base/NotificationCount.vue';

export default {
  name: 'StageAsideTile',
  components: { UserUniversalTile, UserAvatar, BasePriority, BtnExpand, NotificationCount }, // eslint-disable-line
  props: {
    currTask: Object,
    tasks: Array,
    isAdmin: Boolean,
  },
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    stage() { return this.currTask.stage; },
    notificationCount() {
      const getter = this.$store.getters['notification/itemIdsByFilter'];
      return Object.fromEntries(
        this.tasks.map(t => [t.id, getter({ taskId: t.id }).length])
      );
    },
  },
  methods: {
    update(id, field, value) {
      taskListModel.update({ id, field, value });
    },
    getStatusColor(task) {
      const { project } = this.$store.state.project;
      const status = (project.taskStatuses ?? []).find(s => s['@id'] === task.status);
      return status?.color ?? '#000';
    },

  },
};
</script>

<style scoped lang="scss">
.stage-aside {
  &__header {
    border-bottom: 1px solid var(--color-super-light);
    padding-bottom: 10px;
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
  }

  &__title {
    font-size: 17px;
    line-height: 24px;
  }

  &__subtitle {
    font-size: 11px;
    line-height: 24px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--color-middle-gray);
  }

  .closed {
    background: #FAFBFD;
  }

  .closed &__task-manager {
    filter: grayscale(1);
    opacity: .7;
  }

  &__task {
    padding: 6px 14px;
    background: var(--main-bg);
    margin-bottom: 15px;
    border-radius: 6px;
    position: relative;
    display: flex;
    align-items: center;
    gap: 20px;

    &.curr {
      background: #E6ECF2;
    }
  }

  &__status {
    position: absolute;
    left: 0;
    top: 0;
    font-size: 0;
    width: 4px;
    min-width: 4px;
    height: 100%;
    padding: 0;
    border-radius: 6px 0 0 6px;
  }

  &__task-name {
    margin-right: auto;
    font-size: 12px;
    line-height: 15px;
    display: inline-flex;
    gap: 5px;
    align-items: center;
  }

  .closed &__task-name {
    opacity: .5;
    text-decoration: underline;
    text-underline-offset: -.4em;
    text-decoration-skip-ink: none;
    text-decoration-thickness: 2px;
  }

  &__task-priority {
    flex-shrink: 0;
  }

  &__task-manager {
    flex-shrink: 0;
  }

  &__expand {
    margin-left: auto;
    display: none;
  }

  @media (max-width: 1249px) {
    &__expand {
      display: block;
    }

    &__tasks {
      display: none;

      &.expanded {
        display: block;
      }
    }
  }
}
</style>
